const MORE = 'di più';
const LESS = 'di meno';
const FALLBACK_HEIGHT = 50;

export default class Expandable {
    constructor(el, maxHeight) {
        this.$el = $(el);
        this.$el.data('active', false);
        this.maxHeight = maxHeight || FALLBACK_HEIGHT;
    }

    checkHeight() {
        if (this.$el && this.$el.height() > this.maxHeight) {
            this.$el.outerHeight(this.maxHeight).css({overflow: 'hidden', position: 'relative'});
            this.addControl();
        }
    }

    addControl() {
        let control = `<div class="expand-control" title="di più" data-expanded="0">
                           <span class="icon icon__arrow-squared-down"></span>
                       </div>`;

        this.$control = $(control);
        this.$el.append(this.$control);

        const $clickable = this.$el.attr('data-expand-control') ? this.$el : this.$control;
        $clickable.on('click.expand', () => {
            if (this.$control.data('expanded') === 0) {
                this.$el.outerHeight('auto').css('overflow', 'visible');

                let css = this.$el.data('expand-top') ? {top: 0} : {bottom: '-10px'};

                this.$control
                    .attr('title', LESS)
                    .data('expanded', 1)
                    .css(css);

                this.$control
                    .find('.icon')
                    .removeClass('icon__arrow-squared-down')
                    .addClass('icon__arrow-squared-up');
            } else {
                this.$el.outerHeight(this.maxHeight).css('overflow', 'hidden');
                this.$control.attr('title', MORE)
                    .data('expanded', 0)
                    .removeAttr('style');

                this.$control
                    .find('.icon')
                    .addClass('icon__arrow-squared-down')
                    .removeClass('icon__arrow-squared-up');
            }
        });
    }

    init() {
        this.checkHeight();
        this.$el.data('active', true);
    }
}
